import React from "react";
import styled from "styled-components";
import { GripVertical } from "lucide-react";
import { AnyTaggedItem } from "src/types";
import { useIsoContext } from "../isoContext";

interface Props {
  item: AnyTaggedItem;
  onClick?(): void;
  onContextMenu?(event: React.MouseEvent): void;
  handleProps?: any;
  children?: React.ReactNode;
}

export function Task({ item, onClick, onContextMenu, handleProps, children }: Props) {
  const { isLarge } = useIsoContext();
  const draggable = !!handleProps;

  return (
    <Root
      data-testid="task-item"
      onContextMenu={onContextMenu}
      onClick={(e) => e.stopPropagation()}
      $isDraggable={draggable && isLarge}
      $disabled={item.disabled}
    >
      {draggable && !isLarge && (
        <Grip data-testid="task-drag-handle">
          <GripVertical
            {...handleProps}
            size={16}
            stroke="#999"
            style={{ marginLeft: -4, touchAction: "none" }}
          />
        </Grip>
      )}
      <Name data-testid="task-item-name" onClick={onClick}>
        {item.name}
      </Name>
      {children}
    </Root>
  );
}

const Root = styled.div<{ $isDraggable: boolean; $disabled: boolean }>`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  ${({ $isDraggable }) => $isDraggable && `touch-action: none;`}
  ${({ $disabled }) => $disabled && `opacity: 0.5;`}
  gap: 5px;
  background: var(--box-color);
  color: var(--text-primary-color);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.125);
  border-top: 1px solid var(--bg-color) !important;
  border-bottom: 1px solid var(--bg-color) !important;
  padding: 0 !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  @media (min-width: 600px) {
    border-left: 1px solid var(--bg-color) !important;
    border-right: 1px solid var(--bg-color) !important;
  }
  &:hover {
    background: var(--box-color-hover);
  }
`;

const Grip = styled.div`
  display: flex;
  align-items: center;
  margin-right: 1px;
`;

const Name = styled.div`
  flex-grow: 1;
  opacity: 1;
  font-weight: 300;
  padding: 10px 10px 10px 0;
`;
